module.exports = __webpack_public_path__ + "static/media/IMG_0893.1dec20ca.JPG";